import { Tag, Switch } from "antd";
import React from "react";
import moment from "moment";

const RESTRICTED_LABEL = {
  true: "NO",
  false: "YES",
};

const listColumn = (formUpdate) => [
  {
    title: "Date",
    dataIndex: "created",
    render: (date) => {
      const datetime = new Date(date.Time);
      return moment(datetime).format("DD/MM/YYYY");
    },
  },
  {
    title: "Country",
    dataIndex: "country_name",
    render: (text) => {
      return <span style={{ fontWeight: "bold" }}>{text}</span>;
    },
  },
  {
    title: "Allowance",
    dataIndex: "is_restricted",
    render: (text) => {
      const colors = {
        true: "#cb2323",
        false: "#87d068",
      };

      return <Tag color={colors[text]}>{RESTRICTED_LABEL[text]}</Tag>;
    },
  },
  {
    title: "Enable",
    dataIndex: "is_restricted",
    render: (restricted, record) => {
      const payload = {
        id: record.id,
        member_id: record.member_id,
        is_restricted: !record.is_restricted,
        region_code: record.region_code,
      };

      return (
        <Switch
          defaultChecked={restricted}
          onChange={() => formUpdate(payload)}
        />
      );
    },
  },
];

const logsColumn = [
  {
    title: "Date",
    dataIndex: "ts",
    render: (date) => {
      const datetime = new Date(date.Time);
      return moment(datetime).format("DD/MM/YYYY");
    },
  },
  {
    title: "Country",
    dataIndex: "country_name",
    render: (text) => {
      return <span style={{ fontWeight: "bold" }}>{text}</span>;
    },
  },
  {
    title: "Event",
    dataIndex: "event",
    render: (text) => {
      const colors = {
        updated: "#2db7f5",
        created: "#87d068",
        disabled: "#c2c2d6",
        enabled: "#ffc266",
        deleted: "#f10000",
      };
      return <Tag color={colors[text]}>{text.toUpperCase()}</Tag>;
    },
  },
];

export default {
  listColumn,
  logsColumn,
};



// WEBPACK FOOTER //
// ./src/containers/MemberCountry/column.js